import { Pipe, PipeTransform } from '@angular/core';

import { Helper } from '../classes';

@Pipe({
  name: 'documentIcon'
})
export class DocumentIconPipe implements PipeTransform {
  transform(filename?: string): string {
    if (!filename) {
      return '';
    }

    const fileType = Helper.filesHelper()
      .getFileMimeType(filename)
      .split('/')[1];

    return `icon-${fileType}`;
  }
}
